import ErrorPage from '../ErrorPage';

const ServerError = () => (
  <ErrorPage
    code="500"
    title="Erreur serveur"
    description={
      "Une erreur technique est survenue lors du traitement de votre requête. Nous vous invitons à poursuivre votre navigation depuis la page d'accueil."
    }
    showHelp={true}
  />
);

export default ServerError;
